// Catálogo de pestañas de la página de obra (`/obra`, TAR-1277). Fuente única
// para la página y para el bloque "Página de obra" del configurador de Vistas útiles.
//
// Cada pestaña embebe el módulo que ya existe, con la obra fija. Por pestaña:
//   - `permiso`: el mismo que gatea su módulo en el menú. Sin el campo → solo admins
//     de cajas (como Control de presupuestos en el menú).
//   - `fija`: Caja. Siempre está, siempre primera, sin interruptor.
//   - `requiereObraVinculada`: Control de Obra es otra entidad; sin obra vinculada al
//     proyecto la pestaña no aparece.
//
// Se prenden por empresa en `empresa.vistas_config` con clave `obra:<id>`. A diferencia
// de las vistas útiles, están APAGADAS por default: así todas las empresas ven la caja
// de siempre hasta que alguien prende algo.

export const PESTANAS_OBRA = [
  { id: 'caja', title: 'Caja', fija: true },
  { id: 'consolidado', title: 'Análisis consolidado', permiso: 'VER_CAJAS_CONSOLIDADO' },
  { id: 'presupuestos', title: 'Control de presupuestos' },
  { id: 'pagos', title: 'Control de pagos', permiso: 'VER_CONTROL_PAGOS' },
  { id: 'cobros', title: 'Plan de cobros', permiso: 'VER_PLANES_COBRO' },
  { id: 'costo-m2', title: 'Costo por m²', permiso: 'VER_COSTO_M2' },
  { id: 'control-obra', title: 'Control de Obra', permiso: 'VER_CONTROL_OBRA', requiereObraVinculada: true },
];

export const PESTANA_CAJA = PESTANAS_OBRA[0].id;

export const claveConfig = (id) => `obra:${id}`;

// La misma regla que decide si el usuario ve el grupo "Obras" del menú.
export const esAdminDeCajas = (permisos = []) =>
  permisos.includes('VER_CAJAS') && !permisos.includes('CREAR_EGRESO_SIMPLIFICADO');

export const pestanaHabilitadaEmpresa = (empresa, id) =>
  id === PESTANA_CAJA || empresa?.vistas_config?.[claveConfig(id)] === true;

const pestanaPermitida = (pestana, permisos) =>
  (pestana.permiso ? permisos.includes(pestana.permiso) : esAdminDeCajas(permisos));

// Las que muestra el configurador: con interruptor (nunca Caja) y solo si la empresa
// tiene contratado el módulo. Mismo criterio que `vistasLicenciadasParaEmpresa`.
export function pestanasLicenciadasParaEmpresa(empresa) {
  const acciones = empresa?.acciones || [];
  return PESTANAS_OBRA.filter((p) => !p.fija && (!p.permiso || acciones.includes(p.permiso)));
}

// Pestañas visibles para (empresa, permisos del usuario, hay obra de Control de Obra).
export function pestanasVisiblesPara({ empresa, permisos = [], hayControlObra = false }) {
  return PESTANAS_OBRA.filter((p) => p.fija || (
    pestanaHabilitadaEmpresa(empresa, p.id)
    && pestanaPermitida(p, permisos)
    && (!p.requiereObraVinculada || hayControlObra)
  ));
}

// Valor de la query → pestaña activa. Inválida o no visible → Caja.
export const pestanaActiva = (valor, visibles) =>
  (typeof valor === 'string' && visibles.some((p) => p.id === valor) ? valor : PESTANA_CAJA);

// Decide si se cargan las métricas de cabecera y se dibuja la fila de pestañas.
export const tieneMasQueCaja = (visibles) => visibles.some((p) => !p.fija);
